import { render, staticRenderFns } from "./X-modale-notes-chantier.vue?vue&type=template&id=4bbbe964&scoped=true"
import script from "./X-modale-notes-chantier.vue?vue&type=script&lang=js"
export * from "./X-modale-notes-chantier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbbe964",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bbbe964')) {
      api.createRecord('4bbbe964', component.options)
    } else {
      api.reload('4bbbe964', component.options)
    }
    module.hot.accept("./X-modale-notes-chantier.vue?vue&type=template&id=4bbbe964&scoped=true", function () {
      api.rerender('4bbbe964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chantier/avancement/X-modale-notes-chantier.vue"
export default component.exports